import { ResourceOrganization } from './resourceOrganization';
export class ResourceDirectory {
    id: string;
    name: string;
    resource_Organization__C: string;
    organizations: ResourceOrganization;
    organization_Name__C: string
    category__c: string
}